import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { AlertService } from '@src/core/services';
import { EnvService } from '@src/app/modules/env';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BaseResizableComponent } from '@src/app/modules/base';

import { FormData, FormDataControls, ImportData } from './types';
import { ImportService } from './services';

@Component({
  selector: 'app-import-organisations',
  templateUrl: './import-organisations.component.html',
  styleUrls: ['./import-organisations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportOrganisationsComponent extends BaseResizableComponent {
  private readonly importService = inject(ImportService);
  private readonly alertService = inject(AlertService);
  private readonly env = inject(EnvService);

  loading = false;

  tuiElementSize: TuiSizeS | TuiSizeL = 'm';

  form: UntypedFormGroup;

  constructor() {
    super();

    this.form = new UntypedFormGroup(<FormDataControls>{
      file: new UntypedFormControl(undefined, Validators.required),
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.importService
      .getResult()
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(response => {
        if (response?.body) {
          this.form.reset();
          if (response.body.size === 0) {
            this.alertService.success('Файл успешно импортирован');
          } else {
            this.alertService.warning('В файле обнаружены ошибки. Откройте файл с пояснениями.', { autoClose: 30000 });
            this.env.downloadFileByHttpResponse(response);
          }
        }

        this.loading = false;
        this.cdr.markForCheck();
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();

    this.importService.clearImportData();
  }

  onClickSaveButton() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.alertService.error('Загрузите файл');
      return;
    }

    this.loading = true;
    const data = this.mapFormDataToApiData(this.form.value);
    this.importService.startImport(data);
    this.cdr.markForCheck();
  }

  private mapFormDataToApiData(formData: FormData): ImportData {
    const importData: ImportData = {
      files: [formData.file],
    };

    return importData;
  }
}
